import { Component, OnInit } from "@angular/core";
import { Globals } from "../../_models/globals";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiIntegration } from "../../_services/api.integration";
//import {LocalStorageService,SessionStorageService,} from "angular-web-storage";
import { User } from "../../_models/user";
import { environment } from "../../../environments/environment";
import { AlertService } from "../../_services/alert.service";
import * as moment from 'moment';

@Component({
  selector: 'app-admin-wallet-payment',
  templateUrl: './admin-wallet-payment.component.html',
  styleUrls: ['./admin-wallet-payment.component.scss'],
})
export class AdminWalletPaymentComponent implements OnInit {
  imageUrl: string;
  errorMessage: string;
  productImage: string = "/assets/images/default-product.png";
  uploadImage: string;
  paidBy: string;
  paymentMode: any = [];
  selectedPaymentMode: any = {};
  totalAmount: string;
  paymentDate: string;
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  bankName: any = [];
  accountNumber: any = [];
  branch: any = [];
  ifsc: any = [];
  comments: string;
  refNum: string;
  externalRefNum: string;
  amount: string;
  receiptNum: string;
  chequeNum: string;
  payMent: any = {};

  constructor(
    private alertService: AlertService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiIntegration,
    private g: Globals,
    public user: User
  ) {
    this.api
      .getValues("1", "PAYMENT_TYPE", "PAYMENT_TYPE", "PAYMENT_TYPE")
      .subscribe(
        (data: any) => {
          this.paymentMode = data.tripleSetConfigDTOS;
        },
        (err) => {
          this.alertService.error("Error", err);
        }
      );
    this.api.getValues("1", "BANK_DETAILS", "BANK_NAME", "BANK_NAME").subscribe(
      (data: any) => {
        this.bankName = data.tripleSetConfigDTOS;
      },
      (err) => {
        console.log(err);
      }
    );
    this.api
      .getValues("1", "BANK_DETAILS", "ACCOUNT_NUM", "ACCOUNT_NUM")
      .subscribe(
        (data: any) => {
          this.accountNumber = data.tripleSetConfigDTOS;
        },
        (err) => {
          console.log(err);
        }
      );
    this.api.getValues("1", "BANK_DETAILS", "BRANCH", "BRANCH").subscribe(
      (data: any) => {
        this.branch = data.tripleSetConfigDTOS;
      },
      (err) => {
        console.log(err);
      }
    );
    this.api.getValues("1", "BANK_DETAILS", "IFSC_CODE", "IFSC_CODE").subscribe(
      (data: any) => {
        this.ifsc = data.tripleSetConfigDTOS;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  ngOnInit() { }

  reset() {
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
  }

  blurDate() {
    this.statusText1 = "";
    if (!this.paymentDate) {
      this.statusText1 = "Please selecte Date";
    }
  }
  blurPaymentDoneBy() {
    this.statusText2 = "";
    if (!this.paidBy) {
      this.statusText2 = "Please enter payment done by";
    }
  }
  blurPayment() {
    this.statusText3 = "";
    if (!this.selectedPaymentMode || !this.selectedPaymentMode.config) {
      this.statusText3 = "Please enter selected payment mode";
    }
  }
  blurNumber() {
    this.statusText4 = "";
    if (this.selectedPaymentMode.config !== 'CHEQUE') {
      if (!this.chequeNum) {
        this.statusText4 = "Please enter Cheque number";
      }
    } else if (this.selectedPaymentMode.config == 'BANK_TRANSFER') {
      if (!this.refNum) {
        this.statusText4 = "Please enter Reference Number";
      }
    } else {
      if (!this.receiptNum) {
        this.statusText4 = "Please enter Receipt Number";
      }
    }
  }
  blurAmount() {
    this.statusText5 = "";
    if (!this.totalAmount) {
      this.statusText5 = "Please enter Amount";
    }
  }

  loadImage(event) {
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
    this.errorMessage = "";
    this.submitImage();
  }

  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
    this.errorMessage = "";
  }

  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append("file", file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(environment.apiUrl + "api/uploadImageToS3", formData, {
        headers: headerObj,
      })
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.imageUrl = data["message"];
          } else {
            this.imageUrl = "";
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          this.errorMessage = "Upload Image Failed Please Re-try";
        }
      );
  }

  processingPayment() {
    if (!this.paymentDate) {
      this.statusText1 = "Please selecte Date";
    }
    if (!this.paidBy) {
      this.statusText2 = "Please enter payment done by";
    }
    if (!this.selectedPaymentMode || !this.selectedPaymentMode.config) {
      this.statusText3 = "Please enter selected payment mode";
    }
    if (this.selectedPaymentMode.config !== 'CHEQUE') {
      if (!this.chequeNum) {
        this.statusText4 = "Please enter Cheque number";
      }
    } else if (this.selectedPaymentMode.config == 'BANK_TRANSFER') {
      if (!this.refNum) {
        this.statusText4 = "Please enter Reference Number";
      }
    } else {
      if (!this.receiptNum) {
        this.statusText4 = "Please enter Receipt Number";
      }
    }
    if (!this.totalAmount) {
      this.statusText5 = "Please enter Amount";
    }

    if (this.statusText1 !== '' || this.statusText2 !== '' || this.statusText3 !== '' || this.statusText4 !== '' || this.statusText5 !== '') {
      return false;
    }
    this.paymentDate = moment(this.paymentDate).format("MM/DD/YYYY");
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append("Content-Type", "application/json");
    header1 = header1.append("Accept", "application/json");
    header1 = header1.append(
      "Authorization",
      "Bearer " + localStorage.getItem("jwt")
    );
    this.http
      .post(
        environment.apiUrl + "api/updateManuallyCreditTransactionForRazorPay",
        {
          "accountOwnerId": this.route.snapshot.params['id'],
          "amount": this.totalAmount,
          "description": this.paidBy,
          "organizationId": 1,
          "paymentReference": this.selectedPaymentMode.config,
          "referenceOrderNumber": this.chequeNum || this.refNum || this.receiptNum,
          "status": "SUCCESS",
          "transactionDate": this.paymentDate
        },
        { headers: header1 }
      )
      .subscribe(
        (data) => {
          this.g.loaderDisplay = "";
          if (data["code"] == 200) {
            this.alertService.success("Payment Failed", data["message"]);
            this.router.navigate(['/admin/accountOwnerList']);
          } else {
            this.alertService.error("Error", data["message"]);
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        }
      );
  }
}
